import { Injectable } from "@angular/core";
import { Constant } from '../constants/constant';
import { ApiService } from './api.service';
import { SeachQuery } from '../../shared/models';


@Injectable({
    providedIn: 'root'
})
export class DivisionService {
    constructor(
        private http_client: ApiService
    ) { }

    async addNewDivision(data: any) {
        debugger
        try {
            const response = await this.http_client.postData(Constant.new_base_url
                + `api/Divisions`, data);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getAllDivision(divisionName: string) {
        debugger
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/List/Division/${divisionName}`);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }
    async getDivisionDetails(divisionName: any) {
        debugger
        try {
            const response = await this.http_client.getData(Constant.new_base_url
                + `api/Divisions/${divisionName}`);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

    async editDivision(data: any) {
        debugger
        try {
            const response = await this.http_client.putData(Constant.new_base_url
                + `api/Divisions`, data);
            return response;
        }
        catch (error) {
            console.log(error);
            throw error;
        }
    }

}